// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2kCDm","question":"Question_question__g3oS2","description":"Question_description__p9ukm"};